import { useMutation, MutationFunction, MutationOptions } from 'react-query';
import {
    UpdateUtilityVehicleBody,
    UtilityVehicleResponse,
    updateUtilityVehicle,
    CreateUtilityVehicleBody,
    createUtilityVehicle,
} from '../../services/apiSLTP/materials/utilityVehicles';

type UseUpdateUtilityVehicleMutationOptions = MutationOptions<
    UtilityVehicleResponse,
    Error,
    { utilityVehicleId: string; data: UpdateUtilityVehicleBody }
>;

type UseCreateUtilityVehicleMutationOptions = MutationOptions<UtilityVehicleResponse, Error, CreateUtilityVehicleBody>;

export const useUpdateUtilityVehicleMutation = (options?: UseUpdateUtilityVehicleMutationOptions) => {
    const utilityVehicleMutation: MutationFunction<UtilityVehicleResponse, { utilityVehicleId: string; data: UpdateUtilityVehicleBody }> = async ({
        utilityVehicleId,
        data,
    }) => {
        try {
            const response: UtilityVehicleResponse = await updateUtilityVehicle(utilityVehicleId, data);
            return response;
        } catch (error) {
            throw new Error('An unexpected error occurred during utilityVehicle');
        }
    };

    return useMutation(utilityVehicleMutation, options);
};

export const useCreateUtilityVehicleMutation = (options?: UseCreateUtilityVehicleMutationOptions) => {
    const utilityVehicleMutation: MutationFunction<UtilityVehicleResponse, CreateUtilityVehicleBody> = async (data) => {
        try {
            const response: UtilityVehicleResponse = await createUtilityVehicle(data);
            return response;
        } catch (error) {
            throw new Error('An unexpected error occurred during utilityVehicle');
        }
    };

    return useMutation(utilityVehicleMutation, options);
};
